import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"

const useFaqList = () => {
    const [faqs, setFaqs] = useState([])
    const [loadingPagestate, setLoadingPage] = useState(false)

    const getFaqList = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get("/auth/faqs")
            if (res.status === 200) {
                setFaqs(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteFaq = async (id, onSuccess) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.delete(`/auth/faqs/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Announcement")
                if (onSuccess) {
                    onSuccess()
                }
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }


    return {
        faqs,
        getFaqList,
        loadingPagestate,
        deleteFaq,
    }
}

export default useFaqList